var path = '/common/components/loading-spinner/loading-spinner.html';
var html = "<div> <div class=\"pagespinner ng-hide\" ng-show=$ctrl.showSpinner> <div class=\"spinner-border text-primary\" role=status> <span class=sr-only>Loading...</span> </div> </div> </div> ";
window.angular.module('apex.core.templateCache').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;